/*
window.onload = function(){
  var wh = window.innerHeight;
  var sidebar = document.getElementsByClassName('sidebar-section')[0];
  var parentsidebar = sidebar.parentNode;
  var psheight = parentsidebar.clientHeight;
  var heightdiff = wh - psheight -20;
  parentsidebar.style.top = heightdiff + 'px';
}
*/

window.onload = function(){
  var wh = window.innerHeight;
  var sidebar = document.getElementsByClassName('sidebar-section')[0];
  //var parentsidebar = sidebar.parentNode;
  //var psheight = parentsidebar.clientHeight;
  var sidebarheight = sidebar.clientHeight;
  var heightdiff = wh - sidebarheight - 20;
  sidebar.style.top = heightdiff + 'px';
  
  
  //Javascript für Stickybar

  var setinterval = setInterval(checkwidth, 10);
  var getstickybar = document.getElementById('sticky-bar-section');
  var getinnerbar1 = document.getElementsByClassName('wrapper-sticky-bar');
  
  function checkwidth(){
  if(screen.width <= 767){
    var getinnerbar = document.getElementsByClassName('wrapper-sticky-bar');
    getinnerbar[0].style.display = "flex";
    var getinnerbarheigth = getinnerbar[0].clientHeight || getinnerbar.innerHeight;
    var negativheigth = getinnerbarheigth * '-1';
    
    var screenheight = screen.height;
    
    var getstickybar2 = getstickybar.getBoundingClientRect();
    
    if (getstickybar2.bottom <= screenheight) {
      getinnerbar[0].style.position = 'fixed';
      getinnerbar[0].style.bottom = '0px';
    }
    else {
      getinnerbar[0].style.position = 'unset';
      getinnerbar[0].style.bottom = 'unset';
    }
    
  }
  else{
    getinnerbar1[0].style.display = "none";
  }}
  
  if(typeof add_utms === "function"){
  	add_utms();
  }else{}
  
}